import ConstLayout from "./const/layout";
import ConstFeatures from "./const/features";
import {ItemIconClass} from "core/gd/const/item-icon/icon/item-icon-class";
import ConstTours from "./const/tours"
import {StorageProvider} from "./const/storage";
import {FIELDS1} from "core/gd/const/fields/fields"
import {ConstCompany} from "core/gd/const/company";
import CUSTOM_FIELDS_V1 from "./const/fields/custom-fields-v1";
import {ConstProject} from "./const/project";
import {ConstEvents} from "./const/event";
import {ALPHABET_COLORS} from "./skin/aphabet-colors";
import {RAG_COLORS} from "./skin/rag-colors";
import {PRIORITY_COLORS} from "./skin/priority-colors";

import editorLink from './const/editor-link'
import {TASK_CONSTANTS} from "./const/task/task";
import {CURRENCY} from "./const/currency"

module.exports = {

    layout              : ConstLayout,

    ii                  : ItemIconClass,

    systemEvent: require('./const/system-events'),

    project         : ConstProject,
    fields          : FIELDS1,
    customFields    : CUSTOM_FIELDS_V1,
    event           : ConstEvents, //require('./const/event.ts'),

    // customFields: require('./const/fields/custom-fields.js'),

    formFields: require('./const/form-fields.js'),
    aggregate: require('./const/aggregate'),
    display: require('./const/display.js'),

    help: require('./const/misc/help.js'),
    video: require('./const/misc/videos.js'),

    // company: require('./const/company.js'),
    company: ConstCompany,

    bigScreen: require('./const/big-screen.js'),

    task            : TASK_CONSTANTS,
    note: require('./const/note.js'),
    chat: require('./const/chat.js'),
    meeting: require('./const/meeting.js'),



    // updates: require('./const/updates'),
    summary: require('./const/summary'),

    exportToCSV: require('./const/import-export/export-types'),

    editorLink: editorLink,
    timeline: require('./const/modules/timeline'),
    gantt: require('./const/modules/gantt'),
    calendar: require('./const/modules/calendar'),
    board: require('./const/board'),

    features: ConstFeatures,
    tours: ConstTours,

    myWork: require('./const/my-work'),
    reminders: require('./const/reminders'),    // new reminders (old is jsut reminder :(

    lifecycle: require('./const/lifecycle'), // app lifecycle

    /*scheduleStatus: {
        NOT_SCHEDULED: 0,
        SCHEDULED: 1,
        SOMEDAY: 2
    },*/

    attachment: {

        fileType: {
            OTHER: 0,
            IMAGE: 1,
            DOCUMENT: 2,
            GOOGLE_DOCUMENT: 12,
            WEB: 3,
            ARCHIVE: 4,
            SOURCE_CODE: 5,
            VIDEO: 6,
            AUDIO: 7,
            THREED: 8,
            GRAPHIC_SOURCE: 9,
            FONT: 10,
            EBOOK: 11
        },

        googleDriveMimes: {
            DOCUMENT:       'application/vnd.google-apps.document',
            SPREADSHEET:    'application/vnd.google-apps.spreadsheet',
            DRAWING:        'application/vnd.google-apps.drawing',
            FORM:           'application/vnd.google-apps.form',
            PRESENTATION:   'application/vnd.google-apps.presentation',
        },

        preview: {
            UNKNOWN: 0,
            AVAILABLE: 1,
            NOT_AVAILABLE: 2,
        }

    },

    systemStatus: {
        NOT_STARTED: 1,
        IN_PROGRESS: 2,
        IN_REVIEW: 3,
        ON_HOLD: 4,
        COMPLETED: 5,
        CANCELLED: 6,

        isOpen: function(systemStatus){
            return (systemStatus>0 && systemStatus<5)
        },

        isClosed: function(systemStatus) {
            return (systemStatus===5 || systemStatus===6)
        },

        ALL_STATUSES: [1,2,3,4,5,6],
        OPEN_STATUSES: [1,2,3,4],
        CLOSED_STATUSES: [5,6],

        options : [
            {value: 1, label : "Not started"},
            {value: 2, label : "In progress"},
            {value: 3, label : "In review"},
            {value: 4, label : "On hold"},
            {value: 5, label : "Closed / Archived"},
            {value: 6, label : "Cancelled"}
        ]
    },

    systemStatusList: {
        1: 'Not started',
        2: "In progress",
        3: "In review",
        4: "On hold",
        5: "Closed / Archived",
        6: "Cancelled"
    },

    systemStatusColor: {
        1: 1,
        2: 5,
        3: 9,
        4: 10,
        5: 11,
        6: 11
    },

    statusColor: {
        LIGHT_LIGHT_BLUE: 1,
        LIGHT_BLUE: 2,
        BLUE: 3,
        DARK_BLUE: 4,
        GREEN: 5,
        LIGHT_GREEN: 6,
        RED: 7,
        PINK: 8,
        ORANGE: 9,
        VIOLET: 10,
        GRAY: 11,
        LIGHT_GRAY: 12
    },

    // use only in analytics and dashboard charts when need color (!)

    statusColorValue: {
        1: '#28AEF0',
        2: '#28AEF0',
        3: '#28AEF0',
        4: '#28AEF0',
        5: '#43C464',
        6: '#43C464',
        7: '#FF6157',
        8: '#DE35C1',
        9: '#FF841F',
        10: '#7F5AF2',
        11: '#7C848F',
        12: '#7C848F'
    },


    /*reminder: {
        // not sure if we use it
        type: {
            LINK: 1,
            MESSAGE: 2
        }
    },*/


    dashboard: {

        type: {
            EVENTS: 11,
            BEHAVIOUR: 12,
            PROJECTS_USERS: 13,
            COMPANY: 14,
            PROJECT: 15,
            USER: 16
        },

        behaviour: {
            SELF_ORGANIZATION: 1
        }


    },


    emailNotificationFrequency: {
        0: "Immediately (no grouping)",
        15: "Every 15 minutes",
        60: "Every Hour",
        120: "Every 2 hours",
        180: "Every 3 hours",
        240: "Every 4 hours",
        360: "Every 6 hours",
        480: "Every 8 hours",
        720: "Every 12 hours",
        1440: "Once a day"
    },

    myTime: {

        minTaskTime: 5

    },

    report: {

        durationList: {
            7: 'Weekly',
            14: '2 Weeks',
            30: 'Monthly'
        },

        reportType :{
            COMPANY_USER: 1,
            PROJECT: 2,
            COMPANY: 3,
            DEPARTMENT: 4
        }

    },



    presence: {
        DISCONNECTED: 0,
        CONNECTING: 1,
        CONNECTED: 2
    },

    companyRole: {
        CLIENT: 1,
        GUEST: 2,
        USER: 3,
        MANAGER: 4
    },

    companyRoleList: {
        1: 'Client',
        2: 'Guest',
        3: 'User',
        4: 'Manager'
    },


    recent: {
        task: 1,
        project: 2
    },

    taskMessage: {

        type: {
            FIRST:              1,
            MESSAGE:            2,
            NO_REPLY:           3,

            REASSIGN:           10,     // manual reassing

            PRIORITY:           11,
            SET_DEADLINE:       12,
            CHANGE_DEADLINE:    13,
            REMOVE_DEADLINE:    14,
            ESTIMATE:           15,
            MOVE:               16,
            AUTO_REASSIGN:      17,     // auto reassign

            TIME_REPORT:        18,
            AR_CHANGE:          19,

            SCHEDULE_DATE:      20,
            SCHEDULE_SOMEDAY:   21,
            START_END:          22,

            VIEW:               30,
            ADD_USER:           31
        },

        // THIS BROKEN I THINK !!! ToDo:
        typeList: {

            1: 'CREATED',
            2: 'REPLY',
            3: 'COMMENT',

            10: 'SCHEDULE_DATE',
            11: 'SCHEDULE_SOMEDAY',
            12: 'VIEW',
            13: 'NO_REPLY',

            20: 'REASSIGN',
            21: 'PRIORITY',
            22: 'AR_CHANGE',
            23: 'SET_DEADLINE',
            24: 'CHANGE_DEADLINE',
            25: 'REMOVE_DEADLINE',

            40: 'TO_REVIEW',
            41: 'CLOSED',
            42: 'CANCELED',
            43: 'REOPEN',
            44: 'STATUS_CHANGED'
        },

        sysTypeList: {
            1: 'FIRST',
            3: 'COMMENT',
            4: 'INTERRUPT',
            5: 'GETBACK ',
            6: 'NEW_USER',
            7: 'SWITCH',
            8: 'NO_REPLY',
            9: 'RESET_AR',
            10: 'SYSTEM '
        }

    },

    companyUser: {

        workDayDurationList: {
            0: 'Flexible',
            30: '½ hour',
            60: '1 hour',
            90: '1½ hours',
            120: '2 hours',
            150: '2½ hours',
            180: '3 hours',
            210: '3½ hours',
            240: '4 hours',
            270: '4½ hours',
            300: '5 hours',
            330: '5½ hours',
            360: '6 hours',
            390: '6½ hours',
            420: '7 hours',
            450: '7 ½ hours',
            480: '8 hours',
            510: '8½ hours',
            540: '9 hours',
            570: '9½ hours',
            600: '10 hours',
            630: '10½ hours',
            660: '11 hours',
            690: '11½ hours',
            720: '12 hours'
        },

        maxPastDueList: {
            24: '1 day',
            48: '2 days',
            72: '3 days',
            96: '4 days',
            120: '5 days',
            144: '6 days',
            168: '1 week'
        },

        requiredReportTime: {
            0: '0 hours',
            30: '½ hour',
            60: '1 hour',
            90: '1½ hours',
            120: '2 hours',
            150: '2½ hours',
            180: '3 hours',
            210: '3½ hours',
            240: '4 hours',
            270: '4½ hours',
            300: '5 hours',
            330: '5½ hours',
            360: '6 hours',
            390: '6½ hours',
            420: '7 hours',
            450: '7½ hours',
            480: '8 hours',
            510: '8½ hours',
            540: '9 hours',
            570: '9½ hours',
            600: '10 hours',
            630: '10½ hours',
            660: '11 hours',
            690: '11½ hours',
            720: '12 hours'
        }


    },

    alphabetColors  : ALPHABET_COLORS,

    rag: RAG_COLORS,

    priority:{
        levels: {
            emergency: 100,
            blocker: 50
        },
        colors: PRIORITY_COLORS
    },

    tasksGroupBy: {
        none: "",
        scheduleDate: "scheduleDate",
        recentDate: "recentDate"
    },

    taskEstimate: {
        15: '15 min',
        30: '30 min',
        45: '45 min',
        60: '1 hour',
        90: '1½ hours',
        120: '2 hours',
        150: '2½ hours',
        180: '3 hours',
        210: '3½ hours',
        240: '4 hours',
        270: '4½ hours',
        300: '5 hours',
        330: '5½ hours',
        360: '6 hours',
        390: '6½ hours',
        420: '7 hours',
        450: '7 ½ hours',
        480: '8 hours',
        510: '8½ hours',
        540: '9 hours',
        570: '9½ hours',
        600: '10 hours',
        630: '10½ hours',
        660: '11 hours',
        690: '11½ hours',
        720: '12 hours',

        1440: '1 day',
        2880: '2 days',
        4320: '3 days',
        5760: '4 days',
        7200: '5 days',
        8640: '6 days',
        10080: '1 week'
    },

    taskView: {
        current: 'current'
    },

    taskSystemType: {
        TASK: 1,
        SUBTASK: 2,
        PROJECT: 3
    },

    /*busEvents: {
        taskViewOpen:       'task-view-open'
    },*/

    currency: CURRENCY,

    communicationFlow: {
        FIRST: 1,       // First - first message in a flow task A .... or reopen (new block)
        COMMENT: 2,     // Comment - some one comments (without changing AR user) A-(comment)->B
        GET_BACK: 3,    // Get Back - ar change to previous user i.e. A->B->A
        SWITCH: 4,      // Switch  - ar change to other user i.e. A->B->C
        INTERRUPT: 5,   // Interrupt - ar changed by not ar user i.e. A->B C->A
        NO_REPLY: 6     // No reply - ar was changed and original ar user had no chance to reply A->B-(no reply)-C->A (always comes with interrupt)
    },

    storageProvider: StorageProvider,

    projectHistory: {
        CREATED: 1,
        STATUS_UPDATE: 2,
        CLOSED: 3
    },

    eventHistory: {
        CREATED: 1,
        DATE_CHANGED: 2,
        ACCOMPLISHED: 3,
        NOT_ACCOMPLISHED: 4,
        REASSIGNED: 5
    },

    workdayStretchTypes: {
        EXCLUDE_HOLIDAYS: 'exclude-holidays',
        INCLUDE_HOLIDAYS: 'include-holidays',
    },

    suggestedStatuses: [
        // {
        //     id: "new_suggested",
        //     name: "New",
        //     description: 'Just created',
        //     systemStatus: 1,
        //     color: 1
        // },{
        //     id: "in_progress_suggested",
        //     name: "In progress",
        //     description: 'Work in progress',
        //     systemStatus: 2,
        //     color: 2
        // },{
        //     id: "on_hold_suggested",
        //     name: "On hold",
        //     description: 'Work on hold',
        //     systemStatus: 4,
        //     color: 10
        // },

        // NEW
        {
            id: "new_suggested",
            name: "New",
            description: '',
            systemStatus: 1,
            color: 2
        },
        {
            id: "not_started_suggested",
            name: "Not started",
            description: '',
            systemStatus: 1,
            color: 2
        },
        {
            id: "planning_suggested",
            name: "Planning",
            description: '',
            systemStatus: 1,
            color: 2
        },
        {
            id: "kickoff_suggested",
            name: "Kick-Off",
            description: '',
            systemStatus: 1,
            color: 2
        },


        // IN PROGRESS
        {
            id: "open_suggested",
            name: "Open",
            description: '',
            systemStatus: 2,
            color: 5
        },
        {
            id: "in_progress_suggested",
            name: "In Progress",
            description: '',
            systemStatus: 2,
            color: 5
        },
        {
            id: "active_suggested",
            name: "Active",
            description: '',
            systemStatus: 2,
            color: 5
        },

        {
            id: "draft_suggested",
            name: "Draft",
            description: '',
            systemStatus: 2,
            color: 5
        },
        {
            id: "design_suggested",
            name: "Design",
            description: '',
            systemStatus: 2,
            color: 5
        },
        {
            id: "development_suggested",
            name: "Development",
            description: '',
            systemStatus: 3,
            color: 5
        },
        {
            id: "rejected_suggested",
            name: "Rejected",
            description: '',
            systemStatus: 3,
            color: 7
        },



        // REVIEW

        {
            id: "review_suggested",
            name: "Review",
            description: '',
            systemStatus: 3,
            color: 9
        },
        {
            id: "completed_suggested",
            name: "Completed",
            description: '',
            systemStatus: 3,
            color: 9
        },
        {
            id: "approval_suggested",
            name: "Approval",
            description: '',
            systemStatus: 3,
            color: 9
        },
        {
            id: "testing_suggested",
            name: "Testing",
            description: '',
            systemStatus: 3,
            color: 9
        },
        {
            id: "resolved_suggested",
            name: "Resolved",
            description: '',
            systemStatus: 3,
            color: 9
        },

        // ON HOLD
        {
            id: "on_hold_suggested",
            name: "On hold",
            description: '',
            systemStatus: 4,
            color: 10
        },
        {
            id: "pending_suggested",
            name: "Pending",
            description: '',
            systemStatus: 4,
            color: 10
        },

        // CLOSED & cancelled
        {
            id: "archived_suggested",
            name: "Archived",
            description: '',
            systemStatus: 5,
            color: 11
        },
        {
            id: "closed_suggested",
            name: "Closed",
            description: '',
            systemStatus: 5,
            color: 11
        },
        {
            id: "cancelled_suggested",
            name: "Cancelled",
            description: '',
            systemStatus: 6,
            color: 11
        }
    ],

    entityType: {
        TASK: 'task',
        PROJECT: 'project'
    }
};
